import * as d3 from 'd3';

import { pathColorPalette } from '@/app/log-viewer/map/PathColorPalette';
import { Log } from '@/parsing/Log';
import { LogEntryType } from '@/parsing/LogEntry';

import {
  GpsHistoryLocationTimelineMarker,
  TimelineMarker,
  TimelineRow,
  TimelineRowGroup,
} from '../../TimelineData';
import { obtainFreeRowForMarker } from '../obtainFreeRowForMarker';
import { TimelineGeneratorContext } from '../TimelineGeneratorContext';

export function generateGpsHistoryGroupFromLog(
  log: Log,
  ctx: TimelineGeneratorContext,
): TimelineRowGroup {
  const gpsUpdatesRows: TimelineRow[] = [];
  const gpsStartStopRows: TimelineRow[] = [];

  for (const entry of log.entries) {
    if (entry.entryType !== LogEntryType.Generic) {
      continue;
    }
    if (entry.extra.generic?.module !== 'GLOBAL') {
      continue;
    }

    const tooltipContent = entry.content;
    let textOnMarker = '';
    let fillColor = '';
    if (entry.content.startsWith('Location updates paused')) {
      textOnMarker = 'GPS updates paused';
      fillColor = '#f7c5cc';
    } else if (entry.content.startsWith('Location updates started')) {
      textOnMarker = 'GPS updates started';
      fillColor = '#b5fcab';
    } else {
      continue;
    }

    const marker: TimelineMarker = {
      markerId: ctx.nextMarkerId,
      logEntry: entry,
      startTimeMs: entry.date.getTime(),
      endTimeMs: undefined,
      fillColor,
      textOnMarker,
      textOnMarkerColor: undefined,
      tooltipContent,
    };
    ctx.nextMarkerId += 1;

    const row = obtainFreeRowForMarker(gpsStartStopRows, marker);
    row.markers.push(marker);
  }

  const colorArray: d3.ColorCommonInstance[] = [];
  pathColorPalette().forEach((c) => {
    colorArray.push(d3.rgb(c.r, c.g, c.b));
  });
  const colorInterpolator = d3.interpolateRgbBasis(colorArray);

  log.gpsHistory.locations.forEach((l, gpsHistoryLocationIndex) => {
    const entry = log.entries[l.logEntryIndex];
    const lineIndex = ctx.convertLogEntryIndexToLineIndex(l.logEntryIndex);

    const progressOnPath01 = gpsHistoryLocationIndex / (log.gpsHistory.locations.length - 1);
    const fillColor = colorInterpolator(progressOnPath01);

    const marker: GpsHistoryLocationTimelineMarker = {
      markerId: ctx.nextMarkerId,
      logEntry: entry,
      startTimeMs: entry.date.getTime(),
      endTimeMs: undefined,
      fillColor,
      textOnMarker: undefined,
      textOnMarkerColor: undefined,
      tooltipContent: `GPS update at line #${lineIndex}`,
      gpsHistoryLocationIndex,
    };
    ctx.nextMarkerId += 1;

    const row = obtainFreeRowForMarker(gpsUpdatesRows, marker);
    row.markers.push(marker);
  });

  const rowGroup: TimelineRowGroup = {
    name: 'GPS updates',
    rows: gpsStartStopRows.concat(gpsUpdatesRows),
    expanded: true,
  };
  return rowGroup;
}
